import { defaultValue, defined } from '../helpers';
import { saturate } from '../Math';

const MAX_IMG_SIZE = 2000;

export default class MediaImage {
  async load(mediaItem) {
    const imageLoaded = new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => reject();
      img.src = mediaItem.content;
    });

    const img = await imageLoaded;
    this.canvas = resizeInCanvas(img);

    this.aspect = img.width / img.height;

    // Default to a fixed screen-space size which matches the image size, or scale based on a world-space size
    if (mediaItem.width > 0 || mediaItem.height > 0 || mediaItem.focus) {
      this.worldHeight = defaultValue(mediaItem.height, 200);
      if (defined(mediaItem.width)) this.worldHeight = mediaItem.width / this.aspect;
    }
  }

  onReady(worldPos, context) {
    this.hudElement = context.hud.createElement('Image');
    this.hudElement.setCanvas(this.canvas);
    this.hudElement.setWorldPos(worldPos);
    this.hudElement.setWorldHeight(this.worldHeight);
  }

  destroy(context) {
    context.hud.removeElement(this.hudElement);
  }
}

const resizeInCanvas = img => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const scale = saturate(img.width > img.height ? MAX_IMG_SIZE / img.width : MAX_IMG_SIZE / img.height);

  canvas.width = Math.floor(img.width * scale);
  canvas.height = Math.floor(img.height * scale);

  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas;
};
